// Helper function for numeric filtering
export const numberSearch = (a: string | number, b: string | number) => {
	const value = String(a).replace(/[.,]/g, '');
	const filter = String(b).replace(/[.,]/g, '');

	return value.includes(filter);
};
